import React from 'react'
import { ColumnBib, ColumnStartOrder, ColumnNoc, ColumnRank, ColumnName, ColumnResult, ColumnExpander } from "components/common/TableColumns"
import Label from "components/general/Label"
import { findArray } from 'helpers/utils'
import SportCode from 'components/common/SportCode'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

export function ColumnJumpDistance({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'LabelJumpDistance',
}) {

    return (
        {
            Header: <Label data={label} sport={'SJP'}/>,
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'jumpDistance',
            Cell: (props) => {
                const { mirs_discipline } = useUrlFriendlyToParameters()
                let row = props.cell.row.original
                let val = findArray(row.extendedResults, { er_code: ['DIST'] })?.er_value
                if(row?.resultIrm === 'IRF')
                    return <SportCode discipline={mirs_discipline} entity='@IRF' code={row?.resultIrm} abbr={true} />
                else if(row?.resultType === 'POINTS')
                    return val
                else
                    return ''
            },
        }
    )
}

export function ColumnTotalPoints({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderTotalPoints',
}) {

    return (
        {
            Header: <Label data={label} sport={'SJP'}/>,
            accessor: 'sortOrder',
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'totalPoints',
            Cell: (props) => {
                let row = props.cell.row.original
                if (row?.cumData?.resultType === 'POINTS')
                    return row.cumData.resultData
                return ''
            },
        }
    )
}

export function ColumnRound({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'Label1stRound',
    roundNumber,
}) {

    return (
        {
            Header: <Label data={label} sport={'SJP'}/>,
            accessor: (props) => (props?.cumData?.items[roundNumber]?.sortOrder),
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: `round${roundNumber}`,
            Cell: (props) => {
                let row = props.cell.row.original;
                let round = row?.cumData?.items[roundNumber]?.resValue
                let rank = row?.cumData?.items[roundNumber]?.rank
                if(roundNumber === "1" && row?.cumData?.items[1]?.resType === "IRM")
                    return <SportCode discipline='SJP' entity='@IRM' code={row?.cumData?.items[1]?.irm} abbr={true} />
                else
                    return <PlayerStatsType round={round} rank={rank}/>
            },
        }
    )
}

export function ColumnRankFinal({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderRank',
    remove = false,
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => (props?.cumData?.sortOrder),
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Rank',
            remove: remove,
            Cell: (props) => {
                let row = props.cell.row.original
                let val = row?.cumData?.resultType === 'POINTS'
                    ? row?.cumData?.resultRank
                    : ''
                return val
            }
        }
    )
}

export function ColumnQualificationMark({
    disableSort = true,
    className = 'text-center fw-bold',
    headerClassName = 'text-center w-5',
    label = 'HeaderQualificationMark',
    remove = false
}) {
    return (
        {
            Header: <Label data={label} sport={'SJP'}/>,
            remove: remove,
            accessor: 'qualificationMark',// accessor is the "key" in the data 
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'QualMark',
            Cell: (props) => {
                let row = props.cell.row.original
                if(row?.qualificationMark === "Undefined")
                    return ''
                return row?.qualificationMark
            },
        }
    )
}

export function TableColumns1RoundLive() {
    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnJumpDistance({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnQualificationMark({ label: ""}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumns1RoundLiveSM() {
    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnJumpDistance({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnQualificationMark({ label: ""}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumns1RoundFinish() {

    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnJumpDistance({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnQualificationMark({ label: ""}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumns1RoundFinishSM() {

    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnJumpDistance({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnQualificationMark({ label: ""}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsFinalLive() {
    return (
        [
            ColumnRankFinal({ hasIrm: false }),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnRound({ roundNumber: "0"}),
            ColumnRound({ label: "HeaderFinalRound", roundNumber: "1"}),
            ColumnTotalPoints({}),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsFinalLiveSM() {
    return (
        [
            ColumnRankFinal({ hasIrm: false }),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnRound({ roundNumber: "0"}),
            ColumnRound({ label: "HeaderFinalRound", roundNumber: "1"}),
            ColumnTotalPoints({}),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsFinalFinish() {

    return (
        [
            ColumnRankFinal({ hasIrm: false }),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnRound({ roundNumber: "0"}),
            ColumnRound({ label: "HeaderFinalRound", roundNumber: "1"}),
            ColumnTotalPoints({}),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsFinalFinishSM() {

    return (
        [
            ColumnRankFinal({ hasIrm: false }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnRound({ roundNumber: "0"}),
            ColumnRound({ label: "HeaderFinalRound", roundNumber: "1"}),
            ColumnTotalPoints({}),
            ColumnExpander({})
        ]
    )
}

function PlayerStatsType({ round, rank }) {
    if (round !== undefined && rank !== undefined) {
      return (
        <>
          {round} ({rank})
        </>
      )
    }
}